/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GetNotificationsResponse,
  GetUnreadCountResponse,
  MarkAllReadResponse,
  MarkNotificationReadResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetNotificationsResponseFromJSON,
    GetNotificationsResponseToJSON,
    GetUnreadCountResponseFromJSON,
    GetUnreadCountResponseToJSON,
    MarkAllReadResponseFromJSON,
    MarkAllReadResponseToJSON,
    MarkNotificationReadResponseFromJSON,
    MarkNotificationReadResponseToJSON,
} from '../models/index';

export interface DeleteNotificationsIdRequest {
    id: string;
}

export interface GetNotificationsRequest {
    limit?: number;
    offset?: number;
    unreadOnly?: boolean;
    type?: string;
}

export interface UpdateNotificationsIdReadRequest {
    id: string;
    body?: object;
}

/**
 * NotificationsApi - interface
 * 
 * @export
 * @interface NotificationsApiInterface
 */
export interface NotificationsApiInterface {
    /**
     * Dismiss (soft delete) a notification. Dismissed notifications won\'t appear in the list.
     * @summary Dismiss a notification
     * @param {string} id Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    deleteNotificationsIdRaw(requestParameters: DeleteNotificationsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismiss (soft delete) a notification. Dismissed notifications won\'t appear in the list.
     * Dismiss a notification
     */
    deleteNotificationsId(requestParameters: DeleteNotificationsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve paginated list of notifications for the authenticated user, newest first.
     * @summary Get user\'s notifications
     * @param {number} [limit] Number of notifications to return
     * @param {number} [offset] Number of notifications to skip
     * @param {boolean} [unreadOnly] Only return unread notifications
     * @param {string} [type] Filter by notification type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    getNotificationsRaw(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNotificationsResponse>>;

    /**
     * Retrieve paginated list of notifications for the authenticated user, newest first.
     * Get user\'s notifications
     */
    getNotifications(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNotificationsResponse>;

    /**
     * Get the count of unread notifications for badge display.
     * @summary Get unread notification count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    getNotificationsUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnreadCountResponse>>;

    /**
     * Get the count of unread notifications for badge display.
     * Get unread notification count
     */
    getNotificationsUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnreadCountResponse>;

    /**
     * Mark a single notification as read.
     * @summary Mark a notification as read
     * @param {string} id Notification ID
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    updateNotificationsIdReadRaw(requestParameters: UpdateNotificationsIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationReadResponse>>;

    /**
     * Mark a single notification as read.
     * Mark a notification as read
     */
    updateNotificationsIdRead(requestParameters: UpdateNotificationsIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationReadResponse>;

    /**
     * Mark all unread notifications as read.
     * @summary Mark all notifications as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    updateNotificationsReadAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkAllReadResponse>>;

    /**
     * Mark all unread notifications as read.
     * Mark all notifications as read
     */
    updateNotificationsReadAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkAllReadResponse>;

}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI implements NotificationsApiInterface {

    /**
     * Dismiss (soft delete) a notification. Dismissed notifications won\'t appear in the list.
     * Dismiss a notification
     */
    async deleteNotificationsIdRaw(requestParameters: DeleteNotificationsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteNotificationsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/notifications/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismiss (soft delete) a notification. Dismissed notifications won\'t appear in the list.
     * Dismiss a notification
     */
    async deleteNotificationsId(requestParameters: DeleteNotificationsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNotificationsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve paginated list of notifications for the authenticated user, newest first.
     * Get user\'s notifications
     */
    async getNotificationsRaw(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNotificationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['unreadOnly'] != null) {
            queryParameters['unreadOnly'] = requestParameters['unreadOnly'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/notifications`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNotificationsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated list of notifications for the authenticated user, newest first.
     * Get user\'s notifications
     */
    async getNotifications(requestParameters: GetNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNotificationsResponse> {
        const response = await this.getNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the count of unread notifications for badge display.
     * Get unread notification count
     */
    async getNotificationsUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnreadCountResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/notifications/unread-count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnreadCountResponseFromJSON(jsonValue));
    }

    /**
     * Get the count of unread notifications for badge display.
     * Get unread notification count
     */
    async getNotificationsUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnreadCountResponse> {
        const response = await this.getNotificationsUnreadCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mark a single notification as read.
     * Mark a notification as read
     */
    async updateNotificationsIdReadRaw(requestParameters: UpdateNotificationsIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationReadResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNotificationsIdRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/notifications/{id}/read`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkNotificationReadResponseFromJSON(jsonValue));
    }

    /**
     * Mark a single notification as read.
     * Mark a notification as read
     */
    async updateNotificationsIdRead(requestParameters: UpdateNotificationsIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationReadResponse> {
        const response = await this.updateNotificationsIdReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark all unread notifications as read.
     * Mark all notifications as read
     */
    async updateNotificationsReadAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkAllReadResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/notifications/read-all`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkAllReadResponseFromJSON(jsonValue));
    }

    /**
     * Mark all unread notifications as read.
     * Mark all notifications as read
     */
    async updateNotificationsReadAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkAllReadResponse> {
        const response = await this.updateNotificationsReadAllRaw(initOverrides);
        return await response.value();
    }

}
